import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const FreeOTPIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <defs>
        <linearGradient
          id="a"
          x1={60}
          x2={60}
          y1={0}
          y2={120}
          gradientTransform="scale(.2)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#2bfefe",
              stopOpacity: 1
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1852ef",
              stopOpacity: 1
            }}
          />
        </linearGradient>
      </defs>
      <path
        d="M2.2 0h19.6c1.216 0 2.2.984 2.2 2.2v19.6c0 1.216-.984 2.2-2.2 2.2H2.2C.983 24 0 23.016 0 21.8V2.2C0 .983.984 0 2.2 0Zm0 0"
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "url(#a)"
        }}
      />
      <path
        d="M17.734 8.645 12 5.602 6.238 8.629v6.426L12 18.265l5.762-3.21V8.813m-2.957 1.421L12 11.75l-2.805-1.516-2.62-1.421L12 5.953l5.426 2.86Zm2.93-1.59h.003l.024.012m-6.075 9.082v-5.797L6.551 9.152v5.72Zm5.762-2.867-5.137 2.867v-5.797l5.137-2.789Zm0 0"
        style={{
          stroke: "none",
          fillRule: "evenodd",
          fill: "var(--theme-neutral-0)",
          fillOpacity: 1
        }}
      />
    </Icon>
  );
};
